import * as React from 'react';

export function IconKlarna(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 58 32" fill="none" {...props}>
      <title>Klarna</title>
      <g clipPath="url(#prefix__clip0_17_4)">
        <path
          d="M52.07 0H5.53A5.53 5.53 0 000 5.53v20.94A5.53 5.53 0 005.53 32h46.54a5.53 5.53 0 005.53-5.53V5.53A5.53 5.53 0 0052.07 0z"
          fill="#FFB3C7"
        />
        <path
          d="M52.216 18.747a1.37 1.37 0 00-1.365 1.377c0 .76.611 1.377 1.365 1.377a1.37 1.37 0 001.364-1.377 1.37 1.37 0 00-1.364-1.377zm-4.49-1.064c0-1.041-.881-1.885-1.97-1.885-1.087 0-1.97.844-1.97 1.885 0 1.04.883 1.885 1.97 1.885 1.089 0 1.97-.844 1.97-1.885zm.008-3.664h2.174v7.327h-2.174v-.468a3.787 3.787 0 01-2.155.67c-2.116 0-3.832-1.73-3.832-3.865 0-2.136 1.716-3.866 3.832-3.866.8 0 1.54.248 2.155.67v-.468zm-17.398.954v-.954H28.11v7.327h2.231v-3.42c0-1.155 1.24-1.775 2.1-1.775h.026V14.02c-.883 0-1.695.381-2.131.954zm-5.544 2.71c0-1.041-.882-1.885-1.97-1.885s-1.97.844-1.97 1.885c0 1.04.882 1.885 1.97 1.885s1.97-.844 1.97-1.885zm.007-3.664h2.174v7.327h-2.174v-.468a3.788 3.788 0 01-2.155.671c-2.116 0-3.832-1.731-3.832-3.866 0-2.136 1.716-3.866 3.832-3.866.8 0 1.54.248 2.155.67v-.468zm13.085-.197c-.868 0-1.69.272-2.24 1.023v-.825H33.48v7.326h2.191v-3.85c0-1.114.74-1.66 1.632-1.66.955 0 1.505.576 1.505 1.645v3.865h2.171v-4.66c0-1.704-1.343-2.864-3.095-2.864zm-22.239 7.524h2.276V10.754h-2.275v10.592zm-9.995.003h2.41V10.752H5.65V21.35zm8.427-10.597a8.468 8.468 0 01-2.464 6.015l3.33 4.582h-2.976l-3.62-4.98.935-.706a6.104 6.104 0 002.438-4.911h2.357z"
          fill="#0A0B09"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_17_4">
          <path fill="#fff" d="M0 0h57.6v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
